import type { PropertyView, SupportedKeys } from './property.type'
import { normalizePropertyVisibleViews } from './property-field.metadata'

export type PropertyVisibilityView = PropertyView | 'restore'

const resolveView = (
  view: PropertyVisibilityView | undefined,
): PropertyView | undefined => {
  switch (view) {
    case 'restore':
      return 'removal'
    default:
      return view
  }
}

const getLegacyVisibility = (
  property: SupportedKeys,
  view: PropertyView | undefined,
): boolean | undefined => {
  switch (view) {
    case 'references':
      return property.hideInRef == null ? undefined : !property.hideInRef
    case 'inventory':
      return property.hideInInv == null ? undefined : !property.hideInInv
    case 'removal':
      return property.hideInRem == null ? undefined : !property.hideInRem
    case 'shop':
      return false
    case 'app':
      return undefined
    default:
      return undefined
  }
}

export const isPropertyVisibleInView = (
  property: SupportedKeys,
  view: PropertyVisibilityView | undefined,
): boolean => {
  const resolvedView = resolveView(view)
  if (!resolvedView) return true

  const visibleInViews = property.visibleInViews
  if (Array.isArray(visibleInViews)) {
    return normalizePropertyVisibleViews(visibleInViews).includes(resolvedView)
  }

  const legacyVisibility = getLegacyVisibility(property, resolvedView)
  if (legacyVisibility != null) return legacyVisibility

  return resolvedView !== 'app'
}
